import ScreenHeader from "../../../CommonComponents/ScreenHeader";
import InfoBanner from "./components/InfoBanner";
import MilestoneExpandCircle from "./components/MilestoneExpandCircle";
import MilestoneAmplifyBrand from "./components/MilestoneAmplifyBrand";
import MilestonePublishGroup from "./components/MilestonePublishGroup";
import ReferGroupsBanner from "./components/ReferGroupsBanner";
import "./Referrals.css";

const Referrals = () => {
  return (
    <div className="referrals-container">
      <ScreenHeader title="Your Supporter Circle Milestones" />
      <InfoBanner />
      <div className="referrals-layout">
        <div className="referrals-milestones-row">
          <MilestoneExpandCircle />
          <MilestoneAmplifyBrand />
          <MilestonePublishGroup />
        </div>
        <ReferGroupsBanner />
      </div>
    </div>
  );
};

export default Referrals;
